import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../../components/modal/confirmModal";
import SuccessModal from "../../../../components/modal/successModal";
import { routes } from "../../../../routes";
import {
  deleteStakeholderCustomer,
  searchStakeholderCustomer,
} from "../../../../services/customerStakeholder";
import { SearchCurrentStakeholderContext } from "../searchContext";
import NotFound from "../../../../components/common/notFound";
import { SUCCESS_CODE } from "../../../../lib/const";
import FailModal from "../../../../components/modal/failModal";
import { PAGES, PERMISSION_DATA } from "../../../../lib/const";
import usePermission from "../../../../lib/hooks/usePermisson";

const Content = () => {
  const navigate = useNavigate();
  let no = 0;
  const [roleUser] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.STAKEHOLDER
  );
  const [dataSource, setDataSource] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchCurrentStakeholderContext);

  const fetchStakeholderCustomer = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchStakeholderCustomer(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;
      if (res?.data?.code === SUCCESS_CODE) {
        setDataSource(objectValue);
        setSearchValues(objectValue);
        setPageValues(pageValue);
      } else {
        setDataSource([]);
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  useEffect(() => {
    if (search) {
      fetchStakeholderCustomer(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchStakeholderCustomer, searchValues, pageValues, search, setSearch]);

  const columns = [
    {
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      render: () => <span>{(no += 1)}</span>,
    },
    {
      title: "ปีงบประมาณ",
      dataIndex: "yearOfBudget",
      key: "yearOfBudget",
      sorter: (a, b) => a.yearOfBudget - b.yearOfBudget,
    },
    {
      title: "ชื่อบริษัท",
      dataIndex: "companyNameTh",
      key: "companyNameTh",
      sorter: (a, b) => a.companyNameTh - b.companyNameTh,
      render: (_, record) => (
        <>
          <div style={{ fontWeight: 600 }}>{record.companyNameTh}</div>
          <div style={{ color: "#82858E" }}>{record.companyNameEn}</div>
        </>
      ),
    },
    {
      title: "สัญชาติผู้มีส่วนได้ส่วนเสีย",
      dataIndex: "nationalityName",
      key: "nationalityName",
      sorter: (a, b) => a.nationalityName - b.nationalityName,
    },
    {
      title: "ประเด็นติดต่อต่างๆ ",
      dataIndex: "topicDetail",
      key: "topicDetail",
      sorter: (a, b) => a.topicDetail - b.topicDetail,
    },
    {
      title: "รายชื่อเจ้าหน้าที่ติดต่อ ",
      dataIndex: "staffName",
      key: "staffName",
      sorter: (a, b) => a.staffName - b.staffName,
    },
    {
      title: "รายละเอียดการติดต่อ ",
      dataIndex: "staffDetail",
      key: "staffDetail",
      sorter: (a, b) => a.staffDetail - b.staffDetail,
    },
    {
      width: 120,
      align: "center",
      title: "การจัดการ",
      dataIndex: "management",
      key: "management",
      render: (_, record) => (
        <Space>
          {!roleUser[0]?.isEdit &&
            !roleUser[0].isDelete &&
            roleUser[0]?.isView && (
              <Tooltip placement="bottom" title={"ดูข้อมูล"}>
                <Button
                  className="btn-view"
                  shape="circle"
                  icon={<EyeFilled style={{ color: "#2e90fa" }} />}
                  onClick={() =>
                    navigate(
                      routes.view_customer_stakeholder +
                        "/" +
                        record.stakeholdersId
                    )
                  }
                />
              </Tooltip>
            )}
          {roleUser[0]?.isEdit && (
            <Tooltip placement="bottom" title={"แก้ไข"}>
              <Button
                style={{ backgroundColor: "#FEF1DF", border: 0 }}
                shape="circle"
                onClick={
                  () =>
                    navigate(
                      routes.view_customer_stakeholder +
                        "/" +
                        record.stakeholdersId
                    )
                  // navigate(
                  //   routes.view_customer_stakeholder +
                  //     "/00ccdfe1-4e24-427c-a1ec-fc07f62490eb"
                  // )
                }
              >
                <EditOutlined style={{ color: "#F79009" }} />
              </Button>
            </Tooltip>
          )}
          {roleUser[0]?.isDelete && (
            <Tooltip placement="bottom" title={"ลบ"}>
              <Button
                style={{ backgroundColor: "#FDE7E5", border: 0 }}
                shape="circle"
                onClick={() => {
                  setConfirmModal({
                    type: "delete",
                    show: true,
                    id: record.stakeholdersId,
                  });
                }}
              >
                <DeleteFilled style={{ color: "#F04438" }} />
              </Button>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const handleDelete = async () => {
    const res = await deleteStakeholderCustomer(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setSearch(true);
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: "",
    });
  };

  const onSorter = (pagination, filters, sorter) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "stakeholdersId",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  return (
    <>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด <span className="pr-purple">{pageValues.total}</span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </>
  );
};

export default Content;
